import { LOCATION_CHANGE } from '../../../../../shared/frontend/libs/router/redux-store';
import { TLoadRealmSearchDataAction, UPDATE_REALMS_SEARCH_DATA } from '../actions/realmActions';
import { TAction } from '../../../../../shared/frontend/scripts/actions/types/action';

export default function realmSearchReducer(
  state: Partial<any> = [],
  action: TAction<TLoadRealmSearchDataAction>
): Partial<any> {
  switch (action.type) {
    case UPDATE_REALMS_SEARCH_DATA: {
      return [].concat(action.payload as any);
    }
    case LOCATION_CHANGE: {
      return [];
    }
    default:
      return state;
  }
}
